import NicolasPitois from '@/assets/img/NicolasPitois.jpg'
import OlivierPotellet from '@/assets/img/OlivierPotellet.jpg'

export const exchanges = [
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #1 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			},
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			},
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #2 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #3 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #4 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #5 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #6 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #7 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #8 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #9 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #10 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #11 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #12 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #13 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	},
	{
		date: new Date(2018, 0, 13),
		title: 'Lettre de mission #14 prête pour la signature',
		messages: [
			{
				user: {
					name: 'Nicolas Pitois',
					img: NicolasPitois
				},
				date: new Date(2018, 0, 13),
				message: 'Bonjour M. Durand,<br/>La lettre de mission pour votre projet d\'investissement est prête pour la signature.<br/>Cordialement'
			},
			{
				user: {
					name: 'Pierre Durand',
					img: 'https://scontent-frx5-1.xx.fbcdn.net/v/t1.0-9/28472124_10213611233147237_3439682089754223558_n.jpg?_nc_cat=0&oh=b916cb497d4db73433bbd8c3952d445d&oe=5C242CDD'
				},
				date: new Date(2018, 0, 7),
				message: 'Bonjour M. Pitois,<br/>Merci, la lettre est signée.'
			}
		]
	}
]

export const advisors = [
	{
		first_name: 'Nicolas',
		last_name: 'Pitois',
		picture: NicolasPitois,
		title: 'Directeur Associé',
		phone: '+33 (0)1 53 43 13 13',
		isAvailable: true
	},
	{
		first_name: 'Olivier',
		last_name: 'Potellet',
		picture: OlivierPotellet,
		title: 'Directeur Associé',
		phone: '+33 (0)1 53 43 13 13',
		isAvailable: false
	}
]



// WEBPACK FOOTER //
// ./src/fixtures/advisors.js